export const BEHAVIOR_TRANSFORMERS = Object.freeze([
  // use only lowercase names
  "composer-position:correct-scroll-position",
  "composer-position:editor-touch-move",
  "discovery-topic-list-load-more",
  "full-page-search-load-more",
  "post-menu-toggle-like-action",
  "post-stream-error-loading",
  "topic-list-item-click",
]);

export const VALUE_TRANSFORMERS = Object.freeze([
  // use only lowercase names
  "admin-reports-show-query-params",
  "bulk-select-in-nav-controls",
  "category-available-views",
  "category-description-text",
  "category-display-name",
  "category-text-color",
  "composer-editor-quoted-post-avatar-template",
  "composer-editor-reply-placeholder",
  "composer-reply-options-user-link-name",
  "composer-reply-options-user-avatar-template",
  "composer-save-button-label",
  "composer-service-cannot-submit-post",
  "create-topic-label",
  "flag-button-render-decision",
  "flag-button-dynamic-class",
  "flag-button-disabled-state",
  "flag-description",
  "flag-custom-placeholder",
  "flag-formatted-name",
  "hamburger-dropdown-click-outside-exceptions",
  "header-notifications-avatar-size",
  "home-logo-href",
  "home-logo-image-url",
  "home-logo-minimized",
  "invite-simple-mode-topic",
  "latest-topic-list-item-class",
  "like-button-render-decision",
  "mentions-class",
  "more-topics-tabs",
  "move-to-topic-merge-options",
  "move-to-topic-move-options",
  "navigation-bar-dropdown-icon",
  "navigation-bar-dropdown-mode",
  "parent-category-row-class",
  "parent-category-row-class-mobile",
  "post-article-class",
  "post-avatar-class",
  "post-avatar-size",
  "post-avatar-template",
  "post-class",
  "post-event-listener",
  "post-flag-available-flags",
  "post-flag-title",
  "post-menu-buttons",
  "post-menu-collapsed",
  "post-meta-data-edits-indicator-label",
  "post-meta-data-infos",
  "post-meta-data-poster-name-suppress-similar-name",
  "post-notice-component",
  "post-show-topic-map",
  "post-small-action-class",
  "post-small-action-custom-component",
  "post-small-action-icon",
  "poster-name-user-title",
  "poster-name-class",
  "quote-params",
  "small-user-attrs",
  "tag-separator",
  "topic-list-class",
  "topic-list-columns",
  "topic-list-header-sortable-column",
  "topic-list-item-class",
  "topic-list-item-expand-pinned",
  "topic-list-item-mobile-layout",
  "topic-list-item-style",
  "user-field-components",
  "user-menu-notification-item-acting-user-avatar",
  "user-notes-modal-subtitle",
]);
